import { ExportProps } from '~types/exportProps';

import { formatDateString } from '~libs/dayjs';

import { selectClients } from '~main/selectors/clients/clients';
import { selectStatuses } from '~support-at-home/selectors/supplierInvoices';
import { selectSuppliers } from '~support-at-home/selectors/suppliers';

const fields: ExportProps = {
  reference: {
    type: 'text-like',
    caption: 'Reference',
    checked: true,
    field: 'reference',
    placeholder: 'Filter...',
    columnDef: {
      id: 'reference',
      header: 'Reference',
      type: 'text',
    },
  },

  items_reference: {
    type: 'text-like',
    caption: 'SII Reference',
    checked: true,
    field: 'items.reference',
    placeholder: 'Filter...',
    columnDef: {
      id: 'items.reference',
      header: 'SII Reference',
      type: 'text',
      deriveValue: (row) => row.items?.reference ?? '',
    },
  },

  supplier_id: {
    type: 'multi-lookup',
    field: 'supplier_id',
    caption: 'Supplier',
    placeholder: 'All',
    selectorOptions: selectSuppliers,
    columnDef: {
      id: 'supplier_id',
      header: 'Supplier',
      type: 'text',
      deriveValue: (row) => row.supplier?.name ?? '',
    },
  },

  due_date: {
    type: 'date-range',
    field: 'due_date',
    caption: 'Due Date',
    checked: false,
    columnDef: {
      id: 'due_date',
      header: 'Due Date',
      type: 'text',
      deriveValue: (row) => formatDateString(row.due_date),
    },
  },
  created_at: {
    type: 'date-range',
    field: 'created_at',
    caption: 'Created At',
    checked: false,
    columnDef: {
      id: 'created_at',
      header: 'Created At',
      type: 'text',
      deriveValue: (row) => formatDateString(row.created_at),
    },
  },
  updated_at: {
    type: 'date-range',
    field: 'updated_at',
    caption: 'Updated At',
    checked: false,
    columnDef: {
      id: 'updated_at',
      header: 'Updated At',
      type: 'text',
      deriveValue: (row) => formatDateString(row.updated_at),
    },
  },

  client_id: {
    type: 'multi-lookup',
    field: 'client_id',
    caption: 'Client',
    placeholder: 'All',
    selectorOptions: selectClients,
  },

  invoice_date: {
    type: 'date-range',
    field: 'invoice_date',
    caption: 'Invoice Date',
    checked: true,
    columnDef: {
      id: 'invoice_date',
      header: 'Invoice Date',
      type: 'text',
      deriveValue: (row) => formatDateString(row.invoice_date) || '-',
    },
  },

  status: {
    type: 'multi-lookup',
    field: 'status_id',
    columnField: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectStatuses,
    columnDef: {
      id: 'status',
      header: 'Status',
      type: 'text',
      deriveValue: (row) => row.status?.name ?? '',
    },
  },
};

export default fields;
